<template>
  <div>
    <el-form-item label="最大值">
      <el-input-number v-model="activeData.max" placeholder="最大输入值" />
    </el-form-item>
    <el-form-item label="最小值">
      <el-input-number v-model="activeData.min" placeholder="最小输入值" />
    </el-form-item>
    <el-form-item label="步长">
      <el-input-number :min="1" v-model="activeData.step" placeholder="输入每次增加的数值" />
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'ConfigItemSlider',
  props: ['activeData']
}
</script>

<style scoped></style>
